export interface ReplayBallState {
  id: number;
  x: number;
  y: number;
  prevY?: number;
  vx?: number;
  vy?: number;
}

export interface ReplayHandState {
  isLeft: boolean;
  x: number;
  y: number;
}

export interface ReplayFrame {
  timestampMs: number;
  balls: ReadonlyArray<ReplayBallState>;
  hands?: ReadonlyArray<ReplayHandState>;
}

export class ReplayRecorder {
  private frames: ReplayFrame[] = [];
  private recording = false;

  start(): void {
    this.frames = [];
    this.recording = true;
  }

  recordFrame(
    timestampMs: number,
    balls: ReadonlyArray<ReplayBallState>,
    hands?: ReadonlyArray<ReplayHandState>
  ): void {
    if (!this.recording) return;
    this.frames.push({
      timestampMs,
      balls: balls.map((b) => ({ ...b })),
      hands: hands?.map((h) => ({ ...h })),
    });
  }

  stop(): ReplayFrame[] {
    this.recording = false;
    return this.frames.slice();
  }
}
